import { Component, ContentChild, ErrorHandler, Inject, Input, OnInit, TemplateRef} from '@angular/core';





@Component({
  selector: 'widget',
  templateUrl: 'widget.component.html',
  styleUrls: ['./widget.component.css']
})
export class WidgetComponent implements OnInit {

  @Input()
  widget?: EveReportingWidget = null;

  isLoading: boolean;
  hasErrored: boolean;

  @ContentChild('widgetButtonsTemplate')
  widgetButtonsTemplate: TemplateRef<any>;


  widgetTypes = EveReportingWidgetType;




  constructor() { }


  ngOnInit() {
   /* this.widgetError.isError$.subscribe((error) =>
      console.log('component can act on error: ', error)
    );*/
  }

}




export interface EveReportingWidget {
  title?: string;
  backgroundColour?: any;
  widgetType: EveReportingWidgetType;
}






export enum EveReportingWidgetType {
  image,
  text,
  barChart,
  lineChart,
  pieChart,
  fuelGauge,
  textControl,
  numberControl,
  dateTimeControl,
  autoCompleteControl,
  eveUserAutoCompleteControl,
  functionNumberAutoCompleteControl


}

export interface GraphClickEvent {
  type: GraphClickEventTypes
}

export enum GraphClickEventTypes {
  none,
  alert,
  url
}

export interface GraphClickEventAlert extends GraphClickEvent {
  text: string
}

export interface GraphClickEventUrl extends GraphClickEvent {
  url: string
}

